import { render } from "./editor-toolbar.vue?vue&type=template&id=049447bc&scoped=true&ts=true"
import script from "./editor-toolbar.vue?vue&type=script&lang=ts"
export * from "./editor-toolbar.vue?vue&type=script&lang=ts"

import "./editor-toolbar.vue?vue&type=style&index=0&id=049447bc&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049447bc"]])

export default __exports__